import _asyncToGenerator from "D:/wwwroot/dealer-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "D:/wwwroot/dealer-web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { listWarehouse } from '@/api/warehouse.js';
import { listAgentReturn, listAgentReturnInfo, listAgentReturnExport } from '@/api/agent_return.js';
import { mapMutations, mapActions } from 'vuex';
import { listBrand } from '@/api/brand';
import YTable from '@/views/components/table/index.vue';
import { listAgentReturnStatus, listAgentReturnSourceType } from '@/api/dict.js';
export default {
  name: 'order-consign-return-index',
  components: {
    YTable: YTable
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      if (vm.initialized) {
        vm.loadData();
      }
    });
  },
  data: function data() {
    var _this = this;

    return {
      initialized: false,
      orderRowIndex: -1,
      orderLoading: false,
      detailLoading: false,
      searchForm: {
        page: 1,
        pageSize: 5,
        total: 1,
        manufacturerId: null,
        warehouseId: null,
        returnDate: null,
        orderNumber: null,
        status: null,
        brandId: null,
        productNumber: null,
        productName: null,
        specificationModel: null,
        batchNumber: null,
        trackingCode: null,
        remark: null,
        sourceType: 2
      },
      detailForm: {
        page: 1,
        pageSize: 5,
        total: 0,
        consignmentReturnId: 0
      },
      orderList: [],
      detailList: [],
      distributorList: [],
      brandList: [],
      retailerList: [],
      statusList: listAgentReturnStatus(),
      warehouseList: [],
      sellProcessMode: 1,
      searchFormExpand: false,
      sourceTypeList: listAgentReturnSourceType(),
      columns: [{
        label: '退货单号',
        prop: 'orderNumber',
        checked: true,
        width: 200,
        slot: 'orderNumber'
      }, {
        label: '退货单位',
        prop: 'manufacturerName',
        checked: true,
        width: 200
      }, {
        label: '退回仓库',
        prop: 'warehouseName',
        checked: true,
        width: 150
      }, {
        label: '状态',
        prop: 'status',
        checked: true,
        width: 150,
        slot: 'status'
      }, {
        label: '单据来源',
        prop: 'sourceType',
        checked: true,
        width: 100,
        formatter: function formatter(val) {
          var findRow = _this.sourceTypeList.find(function (item) {
            return item.ID === val;
          });

          if (findRow) {
            return '<a class="el-link el-link--' + findRow.type + '"><span class="el-link--inner">' + findRow.name + '</span></a>';
          }
        }
      }, {
        label: '退货数量',
        prop: 'returnQuantitySum',
        checked: true,
        width: 150
      }, {
        label: '退货人',
        prop: 'returnedBy',
        checked: true,
        width: 100
      }, {
        label: '退货日期',
        prop: 'returnDate',
        checked: true,
        width: 100,
        type: 'date'
      }, {
        label: '审核人',
        prop: 'nameReviewer',
        checked: true,
        width: 150
      }, {
        label: '审核时间',
        prop: 'examineTime',
        checked: true,
        width: 100
      }, {
        label: '备注',
        prop: 'remark',
        checked: true,
        width: 200
      }, {
        label: '操作',
        prop: 'operations',
        checked: true,
        width: 100,
        fixed: 'right',
        slot: 'operations',
        dragIgnore: true,
        fixedWidth: true
      }]
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.init();
  },
  methods: _objectSpread(_objectSpread(_objectSpread({}, mapMutations('d2admin/page', ['keepAliveRemove', 'keepAliveClean'])), mapActions('d2admin/db', ['database'])), {}, {
    // 初始化
    init: function init() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var that;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                that = _this2;
                _context.next = 3;
                return that.loadWarehouse();

              case 3:
                _context.next = 5;
                return that.loadBrand();

              case 5:
                if (that.initialized) {
                  _context.next = 8;
                  break;
                }

                _context.next = 8;
                return that.loadData();

              case 8:
                that.initialized = true;

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    loadBrand: function loadBrand() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var that, form;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                that = _this3;
                form = {
                  page: 1,
                  pageSize: 9999
                };
                _context2.next = 4;
                return listBrand(form).then(function (res) {
                  that.brandList = res.list;
                });

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    // 订单列表页加载订单列表
    loadData: function loadData() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var that, form;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                that = _this4;
                that.orderRowIndex = -1;

                if (!that.orderLoading) {
                  _context3.next = 4;
                  break;
                }

                return _context3.abrupt("return");

              case 4:
                form = JSON.parse(JSON.stringify(that.searchForm));
                that.orderList = [];
                that.detailList = [];
                that.orderLoading = true;
                _context3.next = 10;
                return listAgentReturn(form).then(function (res) {
                  that.searchForm.total = res.total;
                  res.list.map(function (row) {
                    var findRow = that.statusList.find(function (item) {
                      return item.ID === row.status;
                    });

                    if (findRow) {
                      row.statusType = findRow.type;
                      row.statusText = findRow.name;
                    }
                  });
                  that.orderList = res.list;
                }).catch(function (e) {});

              case 10:
                that.orderLoading = false;

              case 11:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    dataExport: function dataExport() {
      var that = this;
      var form = JSON.parse(JSON.stringify(that.searchForm));
      form.pageSize = form.total;
      form.toExcel = 1;
      listAgentReturnExport(form).then(function (res) {
        var blob = new Blob([res], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
        }); // type这里表示xlsx类型

        var downloadElement = document.createElement('a');
        var href = window.URL.createObjectURL(blob); // 创建下载的链接

        downloadElement.href = href;
        downloadElement.download = '寄售出库退货单.xlsx'; // 下载后文件名

        document.body.appendChild(downloadElement);
        downloadElement.click(); // 点击下载

        document.body.removeChild(downloadElement); // 下载完成移除元素

        window.URL.revokeObjectURL(href); // 释放掉blob对象
      });
    },
    // 订单列表页搜索提交
    searchFormSubmit: function searchFormSubmit() {
      var that = this;
      that.searchForm.page = 1;
      that.searchForm.total = 0;
      that.loadData();
    },
    // 订单列表页分页跳转
    orderPageChange: function orderPageChange(page) {
      var that = this;
      that.searchForm.page = page;
      that.loadData();
    },
    orderSizeChange: function orderSizeChange(val) {
      var that = this;
      that.searchForm.page = 1;
      that.searchForm.pageSize = val;
      that.loadData();
    },
    // 订单列表单击事件
    orderRowClick: function orderRowClick(row) {
      var that = this;
      that.orderRowIndex = row.rowIndex;
      that.detailForm.page = 1;
      that.detailForm.consignmentReturnId = row.ID;
      that.loadDetail();
    },
    // 订单列表双击事件
    orderRowDbClick: function orderRowDbClick(row) {
      var that = this;
      that.orderRowClick(row);
      that.orderEdit(row);
    },
    // 加载orderRowClick选中订单的明细
    loadDetail: function loadDetail() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var that;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                that = _this5;
                that.detailList = [];
                that.detailLoading = true;
                _context4.next = 5;
                return listAgentReturnInfo(that.detailForm).then(function (res) {
                  that.detailList = res.list;
                  that.detailForm.total = res.total;
                }).finally(function () {
                  that.detailLoading = false;
                });

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    detailPageChange: function detailPageChange(page) {
      var that = this;
      that.detailForm.page = page;
      that.loadDetail();
    },
    detailSizeChange: function detailSizeChange(val) {
      var that = this;
      that.detailForm.page = 1;
      that.detailForm.pageSize = val;

      if (that.detailForm.consignmentReturnId) {
        that.loadDetail();
      }
    },
    orderCreate: function orderCreate() {
      var that = this;
      that.$router.push({
        path: '/order/consign/return/create'
      });
    },
    orderEdit: function orderEdit(row) {
      var that = this;
      that.$router.push({
        path: '/order/consign/return/detail/' + row.ID
      });
    },
    rowClassName: function rowClassName(_ref) {
      var row = _ref.row,
          rowIndex = _ref.rowIndex;
      row.rowIndex = rowIndex;
    },
    loadWarehouse: function loadWarehouse() {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var that;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                that = _this6;
                _context5.next = 3;
                return listWarehouse({
                  page: 1,
                  pageSize: 9999
                }).then(function (res) {
                  that.warehouseList = res.list;
                });

              case 3:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },
    refresh: function refresh() {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _this7.keepAliveClean();

                _context6.next = 3;
                return _this7.$nextTick();

              case 3:
                _this7.$router.replace('/refresh');

              case 4:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }))();
    },
    indexMethod: function indexMethod(index, pagination) {
      return (pagination.page - 1) * pagination.pageSize + index + 1;
    },
    makeBarCode: function makeBarCode(id, code) {
      setTimeout(function () {
        JsBarcode('#barCodeImage' + id, code, {
          height: 40,
          width: 2,
          fontSize: 14,
          margin: 0
        });
      }, 500);
    }
  })
};